import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import './styles/style.css';
import './styles/animation.css';
import './styles/bgLogo.css';
import './styles/testimonialBorder.css';

import Home from './pages/Home';
import AboutCompany from './pages/AboutCompany';
import DevOpsServices from './pages/DevOpsServices';
import DevSecOpsServices from './pages/DevSecOpsServices';
import ManagedServices from './pages/ManagedServices';
import DevelopmentServices from './pages/DevelopmentServices';
import TechnologyPartnership from './pages/TechnologyPartnership';
import WhitelabelSolution from './pages/WhitelabelSolution';
import ContactUs from './pages/ContactUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import ComingSoon from './pages/ComingSoon';

// Scroll to top on every route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Initialize AOS once globally
function AOSInit() {
  useEffect(() => {
    AOS.init({ duration: 800, once: false, offset: 80 });
  }, []);
  return null;
}

function App() {
  return (
    <Router>
      <AOSInit />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutCompany />} />
        <Route path="/devops-services" element={<DevOpsServices />} />
        <Route path="/devsecops-services" element={<DevSecOpsServices />} />
        <Route path="/managed-services" element={<ManagedServices />} />
        <Route path="/development-services" element={<DevelopmentServices />} />
        <Route path="/technology-partnership" element={<TechnologyPartnership />} />
        <Route path="/whitelabel-solution" element={<WhitelabelSolution />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/coming-soon" element={<ComingSoon />} />
      </Routes>
    </Router>
  );
}

export default App;
